module.exports = __webpack_public_path__ + "cbf7fe678e66eb7ae0228989a70df13c.png";